import React from 'react'

const NotAuthorized = () => (
<h3 style={{color:"red", textAlign:"center"}}>You are not Authorized to view this page</h3>
)

export default NotAuthorized